// Exemplo de máscara para telefone:
export const maskPhone = (value) => {
    // Remove tudo que não é dígito
    let v = value.replace(/\D/g, '');

    // Limita no máximo 11 dígitos (ex.: 11999999999)
    v = v.substring(0, 11);

    // Se tiver entre 1 e 2 dígitos: (xx
    if (v.length <= 2) {
        return `(${v}`;
    }
    // Se tiver entre 3 e 6 dígitos: (xx) xxxx
    if (v.length <= 6) {
        return `(${v.slice(0, 2)}) ${v.slice(2)}`;
    }
    // Se tiver entre 7 e 10 dígitos: (xx) xxxx-xxxx
    if (v.length <= 10) {
        return `(${v.slice(0, 2)}) ${v.slice(2, 6)}-${v.slice(6)}`;
    }
    // Se tiver 11 dígitos: (xx) xxxxx-xxxx
    return `(${v.slice(0, 2)}) ${v.slice(2, 7)}-${v.slice(7)}`;
}


export const maskCurrency = (value) => {
    if (!value) return "";
    // Remove tudo que não é dígito
    const newValue = String(value);

    let v = newValue.replace(/\D/g, '');

    // Converte para número (centavos)
    let vNum = parseInt(v, 10);
    if (isNaN(vNum)) {
        vNum = 0;
    }

    // Divide por 100 para "centavos"
    const vFloat = vNum / 100;

    // Formata em pt-BR
    // Exemplo: 12345 -> "123,45"
    return vFloat.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
}

export const formatCurrencyFromDb = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const vNum = parseFloat(value);
    if (isNaN(vNum)) return "";

    return vNum.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
}

export function maskCpfCnpj(value) {
    // Remove tudo que não for dígito
    let cleanValue = value.replace(/\D/g, "");

    // Limita o máximo a 14 dígitos
    if (cleanValue.length > 14) {
        cleanValue = cleanValue.slice(0, 14);
    }

    // Se for até 11 dígitos, consideramos CPF
    if (cleanValue.length <= 11) {
        // 12345678901 => 123.456.789-01
        if (cleanValue.length > 3) {
            cleanValue = cleanValue.replace(/(\d{3})(\d)/, "$1.$2");
        }
        if (cleanValue.length > 6) {
            cleanValue = cleanValue.replace(/(\d{3})\.(\d{3})(\d)/, "$1.$2.$3");
        }
        if (cleanValue.length > 9) {
            cleanValue = cleanValue.replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
        }
    }
    // Caso contrário, consideramos CNPJ (até 14 dígitos)
    else {
        // 12345678901234 => 12.345.678/9012-34
        if (cleanValue.length > 2) {
            cleanValue = cleanValue.replace(/(\d{2})(\d)/, "$1.$2");
        }
        if (cleanValue.length > 5) {
            cleanValue = cleanValue.replace(/(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
        }
        if (cleanValue.length > 8) {
            cleanValue = cleanValue.replace(/(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4");
        }
        if (cleanValue.length > 12) {
            cleanValue = cleanValue.replace(/(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, "$1.$2.$3/$4-$5");
        }
    }

    return cleanValue;
}

/**
 * Aplica máscara de CEP: 99999-999
 */
export function maskCep(value) {
    // remove tudo que não for dígito
    let cleanValue = value.replace(/\D/g, "");

    // CEP => #####-###
    cleanValue = cleanValue.replace(/^(\d{5})(\d)/, "$1-$2");

    return cleanValue;
}